/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Drag Icon component.
 */
export const MaterialDragIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='9.2' cy='7.2' r='1.2' fill={iconColor} />
      <circle cx='13.9998' cy='7.2' r='1.2' fill={iconColor} />
      <circle cx='13.9998' cy='11.9998' r='1.2' fill={iconColor} />
      <circle cx='9.2' cy='11.9998' r='1.2' fill={iconColor} />
      <circle cx='13.9998' cy='16.7996' r='1.2' fill={iconColor} />
      <circle cx='9.2' cy='16.7996' r='1.2' fill={iconColor} />
    </svg>
  );
};

export default MaterialDragIcon;
